import { Button } from '@wework/dieter-ui'
import React from 'react'
import { useSidebar } from '../../hoc/withSidebar'

export default function BulkEditFooter({ onHoldHandler }: any) {
  const { openSideBar } = useSidebar()
  return (
    <div
      style={{
        width: '100%',
        marginTop: 16,
        display: 'flex',
        zIndex: 9999,
        backgroundColor: 'white',
        justifyContent: 'flex-end',
        flexShrink: 0,
      }}
    >
      {/* <Button variant="contained" basic size="small" primary>
        Export .csv
      </Button> */}
      <Button
        variant="contained"
        primary
        size="small"
        onClick={() => openSideBar('Linkeage')}
      >
        Link Spaces
      </Button>
      <Button
        variant="contained"
        primary
        size="small"
        onClick={() => onHoldHandler(true)}
        style={{ marginLeft: 12 }}
      >
        Hold
      </Button>
    </div>
  )
}
